{
  "proposalsTitle": "Proposals",
  "proposalsLead": "Ideas from residents for the town. Support the ones you agree with; the LGU answers each one.",
  "submitProposal": "Submit a proposal",
  "sortSupport": "Most supported",
  "sortNew": "Newest",
  "allBarangays": "All barangays",
  "allStatuses": "Any status",
  "townWide": "Whole town",
  "noProposals": "No proposals yet",
  "noProposalsBody": "Have an idea for the town? Submit it. An office reviews each proposal before it is shown here.",
  "supports": "{count} supports",
  "supportOne": "1 support",
  "support": "Support",
  "supported": "Supported",
  "unsupport": "Remove my support",
  "signInToSupport": "Sign in to support",
  "supportClosed": "This proposal is closed.",
  "pst_open": "Open for support",
  "pst_under_review": "Under review",
  "pst_accepted": "Accepted",
  "pst_in_progress": "In progress",
  "pst_done": "Done",
  "pst_not_pursued": "Not pursued",
  "mod_pending": "Waiting for review",
  "mod_published": "Published",
  "mod_declined": "Not published",
  "officialResponse": "Response from {office}",
  "lastUpdated": "Last updated by {office} on {date}",
  "myProposals": "My proposals",
  "pendingNote": "An office will review your proposal before it is public. You'll be notified.",
  "declinedNote": "This proposal was not published: {reason}",
  "withdraw": "Withdraw",
  "withdrawTitle": "Withdraw this proposal?",
  "withdrawBody": "It will be deleted. You can submit a new one anytime.",
  "withdrawn": "Your proposal was withdrawn.",
  "proposalNotFound": "This proposal isn't available.",
  "newProposalTitle": "Submit a proposal",
  "newProposalLead": "Describe what you'd like the LGU to do and why. Keep it about the town, not about a person.",
  "proposalTitle": "Title",
  "proposalTitleHint": "Short and clear, e.g. \"Shaded benches at the plaza\".",
  "proposalDescription": "Your proposal",
  "proposalDescriptionHint": "What should be done, where, and who would benefit.",
  "whereFor": "For which area?",
  "photo": "Photo",
  "sendForReview": "Send for review",
  "sending": "Sending…",
  "sentTitle": "Sent for review",
  "sentBody": "An office will check it before it is public. You'll get a notification.",
  "viewIt": "View it",
  "checkForm": "Please check the highlighted fields.",
  "lostFoundTitle": "Lost & found",
  "lostFoundLead": "Lost something, or found something? Posts are checked by the LGU first, and contact goes through the office, never directly.",
  "postItem": "Post an item",
  "kind_lost": "Lost",
  "kind_found": "Found",
  "kindAll": "All",
  "allCategories": "All kinds of items",
  "cat_id_documents": "IDs and documents",
  "cat_wallet_money": "Wallet or money",
  "cat_phone_electronics": "Phone or electronics",
  "cat_keys": "Keys",
  "cat_bag": "Bag",
  "cat_pet": "Pet",
  "cat_jewelry": "Jewelry",
  "cat_clothing": "Clothing",
  "cat_other": "Other",
  "noItems": "Nothing posted right now",
  "noItemsBody": "Posts appear here after an office checks them.",
  "lfst_open": "Open",
  "lfst_resolved": "Returned",
  "lfst_closed": "Closed",
  "lfst_expired": "Expired",
  "lostOn": "Lost on {date}",
  "foundOn": "Found on {date}",
  "myPosts": "My posts",
  "myMessages": "My messages to the office",
  "privacyNote": "Never post IDs, faces or full names. Describe the item; the office checks who it belongs to.",
  "itemNotFound": "This post isn't available.",
  "newItemTitle": "Post an item",
  "whatHappened": "What happened?",
  "iLost": "I lost something",
  "iFound": "I found something",
  "itemTitle": "What is it?",
  "itemTitleHint": "For example: \"Black wallet\" or \"Keys on a red lanyard\".",
  "category": "Kind of item",
  "itemDescription": "Description",
  "itemDescriptionHint": "Color, brand, size: anything that helps, but nothing that identifies a person.",
  "date": "When?",
  "place": "Where?",
  "placeHint": "A landmark, jeepney route or building.",
  "privateDetail": "A detail only the office should know",
  "privateDetailHint": "Optional. Something only the owner would know (what's inside, a mark). It's never shown publicly and helps the office check claims.",
  "itemSent": "Your post was sent for review.",
  "itemPending": "An office will check your post before it is public.",
  "itemDeclined": "Not published: {reason}",
  "claimsReceived": "{count} people contacted the office about this.",
  "renew": "Keep it open for 60 more days",
  "renewed": "Your post is open for 60 more days.",
  "closeMine": "I got it back / It's resolved",
  "closePending": "Delete my post",
  "closeTitle": "Close this post?",
  "closeBody": "It will no longer be shown to others.",
  "closeYes": "Yes, close it",
  "closed": "Your post was closed.",
  "expiresOn": "Open until {date}",
  "privateShown": "Only you and the office see this: {detail}",
  "claimLost": "I found this",
  "claimFound": "This might be mine",
  "claimLeadLost": "Tell the office where you found it. They'll contact the owner.",
  "claimLeadFound": "Describe it so the office can check it's yours (what's inside, marks, where you lost it).",
  "claimMessage": "Your message to the office",
  "claimSend": "Send to the office",
  "claimSent": "Sent. The office will check and contact you.",
  "claimStatus": "Your message: {status}",
  "cst_new": "Sent",
  "cst_in_contact": "The office is in touch",
  "cst_confirmed": "Confirmed",
  "cst_rejected": "Not a match",
  "signInToClaim": "Sign in to contact the office about this item",
  "contactName": "Your name",
  "contactMobile": "Mobile number",
  "contactHint": "The office will call or text you. It is not shown to anyone else.",
  "modTitle": "Community moderation",
  "modLead": "Review proposals and lost & found posts before they are public, answer proposals, and handle messages about items.",
  "tabPendingProposals": "Proposals to review",
  "tabProposals": "Published proposals",
  "tabPendingItems": "Posts to review",
  "tabClaims": "Messages",
  "tabItems": "Published posts",
  "statPendingProposals": "Proposals to review",
  "statOpenProposals": "Open proposals",
  "statPendingItems": "Posts to review",
  "statClaims": "Open messages",
  "nothingHere": "Nothing here right now",
  "submittedBy": "From {name} · {date}",
  "deletedAccount": "Deleted account",
  "publish": "Publish",
  "decline": "Don't publish",
  "declineTitle": "Don't publish this?",
  "declineReason": "Reason for the author",
  "declineReasonHint": "They see this. Be kind and specific.",
  "reasonRequired": "Write a short reason.",
  "published": "Published. The author was notified.",
  "declined": "Not published. The author was notified.",
  "answer": "Update status",
  "answerTitle": "Update this proposal",
  "status": "Status",
  "response": "Public response",
  "responseHint": "Shown on the proposal and sent to the author and supporters.",
  "answered": "Saved. The author and supporters were notified.",
  "resolve": "Mark returned",
  "closeItem": "Close",
  "renewItem": "Renew 60 days",
  "resolveTitle": "Close this post?",
  "resolveState": "How did it end?",
  "resolvedOpt": "Returned to the owner",
  "closedOpt": "Closed (not returned)",
  "note": "Note for the poster",
  "resolvedToast": "Post closed. The poster was notified.",
  "renewedToast": "Post renewed for 60 days.",
  "posterContact": "Posted by {name}",
  "privateDetailStaff": "Private detail: {detail}",
  "noPrivateDetail": "No private detail given.",
  "claimAbout": "About: {title}",
  "claimFrom": "From {name}",
  "claimUpdate": "Update",
  "claimUpdateTitle": "Update this message",
  "claimNote": "Note to the sender",
  "claimNoteHint": "They see this, e.g. where to pick up the item.",
  "claimSaved": "Saved. The sender was notified.",
  "openClaims": "{count} open messages",
  "readOnly": "You can view. Editors and office heads can publish, answer and close posts."
}
